import ExceptionalHomes from "./ExceptionalHomes";
import Contact from "./Contact";
import About from "./About";
import CEOMessage from "./CEOMessage";
import Construction from "./Construction";
import Materials from "./Materials";
import Luxury from "./Luxury";
import Designed from "./Designed";

export default function InfoAndSlideShow({ section }) {
    const renderSection = () => {
        switch (section) {
            case 1:
                return <ExceptionalHomes />;
            case 2:
                return <Contact />;
            case 3:
                return <About />;
            case 4:
                return <CEOMessage />;
            case 5:
                return <Materials />;
            case 6:
                return <Construction />;
            case 7:
                return <Luxury />;
            case 8:
                return <Designed />;
            default:
                return <div>No content available</div>;
        }
    };

    return <>{renderSection()}</>;
}
